import { InfoClientProperties, UpdateClientInfoProperties } from '../../../redux/API/ClientAPIHelpers/clientProperties';

export enum ACTIONS {
	setId = 'setId',
	setState = 'setState',
	setFirstName = 'setFirstName',
	setLastName = 'setLastName',
	setDateOfBirth = 'setDateOfBirth',
	setGender = 'setGender',
	setEmail = 'setEmail',
	setSecondaryEmail = 'setSecondaryEmail',
	setParentPhoneNumber = 'setParentPhoneNumber',
	setSecondaryPhoneNumber = 'setSecondaryPhoneNumber',
	setAddress = 'setAddress',
	setCity = 'setCity',
	setZip = 'setZip',
	setStatus = 'setStatus',
	setDefaultBcbaId = 'setDefaultBcbaId',
	setTherapists = 'setTherapists',
	setInsurances = 'setInsurances',
	setDiagnosisCodeId = 'setDiagnosisCodeId',
	setCaseCoordinatorId = 'setCaseCoordinatorId',
	setNickName = 'setNickName',
	setMBHId = 'setMBHId',
	setBranchId = 'setBranchId',
	setOtherDiagnosisCodes = 'setOtherDiagnosisCodes',
}

export interface ActionProperties {
	payload: any;
	type: keyof typeof ACTIONS;
}
export const clientReducer = (state: InfoClientProperties | UpdateClientInfoProperties, action: ActionProperties) => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setId:
			return {
				...state,
				id: payload,
			};
		case ACTIONS.setDiagnosisCodeId:
			return {
				...state,
				diagnosisCodeId: payload,
			};
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setFirstName:
			return {
				...state,
				firstName: payload,
			};
		case ACTIONS.setNickName:
			return {
				...state,
				nickName: payload,
			};
		case ACTIONS.setLastName:
			return {
				...state,
				lastName: payload,
			};
		case ACTIONS.setDateOfBirth:
			return {
				...state,
				dateOfBirthday: payload,
			};
		case ACTIONS.setGender:
			return {
				...state,
				gender: payload,
			};
		case ACTIONS.setEmail:
			return {
				...state,
				email: payload,
			};
		case ACTIONS.setParentPhoneNumber:
			return {
				...state,
				parentPhoneNumber: payload,
			};
		case ACTIONS.setAddress:
			return {
				...state,
				address: payload,
			};
		case ACTIONS.setCity:
			return {
				...state,
				city: payload,
			};
		case ACTIONS.setZip:
			return {
				...state,
				zip: payload,
			};
		case ACTIONS.setStatus:
			return {
				...state,
				status: payload,
			};
		case ACTIONS.setDefaultBcbaId:
			return {
				...state,
				defaultBcba: payload,
			};
		case ACTIONS.setTherapists:
			return {
				...state,
				therapists: payload,
			};
		case ACTIONS.setInsurances:
			return {
				...state,
				insurances: payload,
			};
		case ACTIONS.setSecondaryEmail:
			return {
				...state,
				secondaryEmail: payload,
			};
		case ACTIONS.setSecondaryPhoneNumber:
			return {
				...state,
				secondaryNumber: payload,
			};
		case ACTIONS.setCaseCoordinatorId:
			return {
				...state,
				caseCoordinatorId: payload,
			};
		case ACTIONS.setMBHId:
			return {
				...state,
				mbhId: payload,
			};
		case ACTIONS.setOtherDiagnosisCodes:
			return {
				...state,
				otherDiagnosisCodes: payload,
			};
		case ACTIONS.setBranchId:
			return {
				...state,
				branchId: payload,
			};
		default:
			return state;
	}
};
